const n = (e, i = " ") => e.filter(Boolean).join(i);
export {
  n as getUnifiedString
};
